export enum CalendarGranularity {
  Daily = "daily",
  Weekly = "weekly"
}
